import React from "react";
import { AddFormButton, FilterButton } from "../../../../shared/components/TableElements";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const SingleProvider = ({ providerName, providerIcon, providerState, handleClick }) => {
  const { t } = useTranslation("common");

  const renderButton = () => {
    if (providerState === 1) {
      return <AddFormButton type="button" onClick={handleClick}>{t("connect")}</AddFormButton>;
    }
    if (providerState === 2) {
      return <ManageButton type="button" onClick={handleClick}>{t("manage")}</ManageButton>;
    }
    if (providerState === 3) {
      return <FilterButton disabled style={{ opacity: 0.4 }}>{t("coming_soon")}</FilterButton>;
    }
    if (providerState === 4) {
      return <AddFormButton type="button" disabled>{t("connect")}</AddFormButton>;
    }
    return null;
  };

  return (
    <IntegrationCard>
      <LogoBox>
        <img
          src={providerIcon}
          alt={providerName}
          style={{ objectFit: "contain", opacity: providerState === 3 ? 0.4 : 1, maxWidth: "96px", maxHeight: "52px" }}
        />
      </LogoBox>
      <NameCol>
        <ProviderNameText>{providerName}</ProviderNameText>
        {providerState === 2 && (
          <ConnectedBadge>
            <ConnectedDot />
            {t("connected")}
          </ConnectedBadge>
        )}
      </NameCol>
      <div>{renderButton()}</div>
    </IntegrationCard>
  );
};

export default SingleProvider;

export const IntegrationCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fff;
  min-height: 76px;
`;

export const LogoBox = styled.div`
  flex: 0 0 112px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfc;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const NameCol = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const ProviderNameText = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #1a2331;
`;

export const ConnectedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #12805c;
  background: #e6f4ee;
  padding: 3px 9px 3px 8px;
  border-radius: 999px;
  margin-top: 6px;
`;

export const ConnectedDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #12805c;
  flex-shrink: 0;
`;

export const ManageButton = styled.button`
  font-size: 13.5px;
  font-weight: 600;
  padding: 9px 20px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  color: #475467;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;

  &:hover {
    border-color: #98a2b3;
    background: #fafbfc;
  }
`;
